// Footer.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import CameraImg from '../assets/images/camera.svg';
import MenuImg from '../assets/images/menu.svg';

const Footer = () => {
  const navigate = useNavigate();  // React Router's navigation hook

  const handleMenuClick = () => {
    navigate('/'); 
  };
  const handleQRClick = () => {
    navigate('/request-service');  
  };
  return (
    <div className="footer-nav">
      <div className="nav-item" onClick={handleQRClick}>
        <img src={CameraImg} className="logofooter" alt="Camera" />
        <span>Scan QR AC</span>
      </div>
      <div className="nav-item menu" onClick={handleMenuClick}>
        <img src={MenuImg} className="logofooter" alt="Menu" />
        <span>Menu</span>
      </div>
    </div>
  );
};

export default Footer;
